import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const PledgeAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'LotPledge',
    paramId: 'pledgeId',
    attachmentType: AttachmentType.LotPledge,
    closeRoute: 'base-layout.lots.view',
  };

  return <Attachments<cyrian.api.lots.LotPledge & { attachments: any[] }> {...params} />;
};
